import Block from './Block'
import gsap from 'gsap'
import SplitType from 'split-type'
import Video from '../util/Video'

export default class VideoList extends Block {
  getElems() {
    this.list = this.el.querySelector('.b-video-list__list')
    this.previews = this.el.querySelectorAll('.b-video-list__list-preview')
    this.texts = this.el.querySelectorAll('.b-video-list__list-preview .text')
    this.videos = this.el.querySelectorAll('.c-video')
    this.items = this._getItems()
  }

  _getItems() {
    const items = [];

    for (let i = 0; i < this.previews.length; i++) {
      const item = {
        preview: this.previews[i],
        video: this.videos[i]
      }

      items.push(item)
    }

    return items
  }

  init() {
    this.list.addEventListener('wheel', (e) => e.stopPropagation())
    this.lines = new SplitType(this.texts, { types: 'lines, words' }).words

    this.items.forEach((item) => {
      gsap.set(item.video, {
        scale: 0.5,
        yPercent: 80,
        opacity: 0,
        zIndex: -1
      })
    })

    gsap.set(this.items[0].video, {
      opacity: 1,
      zIndex: 1,
      scale: 1,
      yPercent: 0
    })

    this._animDisplay()
  }

  events() {
    this.items.forEach((item) => {
      item.preview.addEventListener('click', () => {
        this.items.forEach((video) => {
          gsap.set(video.video, {
            scale: 0.5,
            yPercent: 80,
            opacity: 0,
            zIndex: -1
          })
          const videoReset = new Video()

          videoReset._resetVideo(video.video)
        })

        gsap.to(item.video, {
          opacity: 1,
          yPercent: 0,
          duration: 0.75,
          ease: 'power3.out'
        })

        gsap.to(item.video, {
          scale: 1,
          delay: 0.75,
          ease: 'power3.out'
        })

        gsap.set(item.video, { zIndex: 1 })
      })
    })
  }

  _animDisplay() {
    this.items.forEach((item) => {
      gsap.set(item.preview.querySelector('.image'), { opacity: 0 })
      gsap.set(item.preview.querySelectorAll('.word'), { yPercent: 100 })

      gsap.to(item.preview.querySelector('.image'), {
        scrollTrigger: {
          trigger: item.preview,
          scroller: this.list
        },
        opacity: 1,
        duration: 0.7,
        ease: 'power3.in'
      })
      gsap.to(item.preview.querySelectorAll('.word'), {
        scrollTrigger: {
          trigger: item.preview,
          scroller: this.list
        },
        yPercent: 0,
        stagger: 0.035
      })
    })
  }
}
